var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-tile",
    [
      _c(
        "v-list-tile-content",
        [
          _c("v-list-tile-title", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.capitalizeEveryWord(_vm.specimen.SpeciesCommonName)
                ) +
                " (" +
                _vm._s(_vm.specimen.SpeciesFullLatinName) +
                ")\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-list-tile-sub-title",
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm8: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.specimen.SpeciesCode != null
                            ? _c("v-flex", { attrs: { xs12: "" } }, [
                                _c("span", { staticClass: "text--primary" }, [
                                  _vm._v("Species Code: "),
                                ]),
                                _vm._v(
                                  _vm._s(_vm.specimen.SpeciesCode) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "text--primary" }, [
                              _vm._v(_vm._s(_vm.specimen.Surveys.length)),
                            ]),
                            _vm._v(" Surveys\n            "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", round: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                `/vegetativemonitoring/specimen/${_vm.specimen.Id}`
                              )
                            },
                          },
                        },
                        [_vm._v(" View")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }